import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const PricingPageHero = () => {
  const scrollToComparison = () => {
    document.getElementById('comparison-table')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Image */}
      <img 
        src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&q=80"
        alt="Camp dining hall with staff preparing meals"
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Warm Overlay (forest green → cream) */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-teal/85 via-midnight-green/75 to-[#F5F1E8]/40" />
      
      {/* Subtle copper accent lines */}
      <div className="absolute inset-0 opacity-10 z-10">
        <div className="absolute top-20 left-10 w-64 h-px bg-copper/30 rotate-12"></div>
        <div className="absolute bottom-32 right-20 w-96 h-px bg-copper/30 -rotate-6"></div>
        <div className="absolute top-1/2 left-1/4 w-48 h-px bg-copper/20 rotate-45"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-ivory mb-6">
          Plans That Fit Every Camp Kitchen
        </h1>
        <p className="text-xl text-ivory/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          From small retreats to large overnight camps, choose the plan that grows with your kitchen and your mission. 
          <span className="text-copper font-semibold">Get a personalized demo and quote</span> for your camp.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            asChild 
            size="lg" 
            variant="copper"
            className="min-w-[200px] shadow-lg hover:shadow-xl transition-all"
          >
            <Link to="/contact">Request a Camp Demo</Link>
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={scrollToComparison}
            className="min-w-[200px] border-2 border-ivory text-ivory bg-ivory/20 hover:bg-ivory/30 hover:border-ivory transition-all"
          >
            Compare Plans
          </Button>
        </div>
      </div>
    </section>
  );
};
